import { render, staticRenderFns } from "./MemberWealth.vue?vue&type=template&id=23d7df0e&scoped=true&"
import script from "./MemberWealth.vue?vue&type=script&lang=js&"
export * from "./MemberWealth.vue?vue&type=script&lang=js&"
import style0 from "./MemberWealth.vue?vue&type=style&index=0&id=23d7df0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d7df0e",
  null
  
)

export default component.exports